import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Tag } from '../../Elements/Tag';
import { Tooltip } from '../../Feedback/Tooltip';
import { Wrapper, List, ListItem } from './styled';
export const ListWithCounter = React.memo(function ListWithCounter({ list }) {
    if (!list) {
        return null;
    }
    return (_jsxs(Wrapper, { "data-testid": 'content-wrapper', children: [list[0], list.length > 1 && (_jsx(Tooltip, { type: 'popper', contentPadding: false, delayHide: 150, trigger: ['hover', 'click'], dataTestId: 'list-counter-tooltip', tooltip: _jsx(List, { children: list.slice(1).map((item) => (_jsx(ListItem, { "data-testid": 'list-counter-item', children: item }, item.replace(/\s/g, '')))) }), children: _jsx(Tag, { dataTestId: 'list-counter-tag', title: ` +${list.length - 1}` }) }))] }));
});
